import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Toaster } from 'react-hot-toast';
import * as Sentry from "@sentry/react";
import { BrandingProvider } from '@/context/BrandingContext';
import ThemeProvider from '@/context/ThemeProvider';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.replayIntegration()
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <BrandingProvider>
        <App />
        <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      </BrandingProvider>
    </ThemeProvider>
  </StrictMode>,
)
